<div class="container">
  @if (regex) {
  @if (!isLoggedIn) {
  <!-- Been here before - only visible if not logged in -->
  <div class="row">
    <div class="col-12 col-lg-6">
      <h2 class="fs-23 mb-2 text-col40 fw400">Been here before?</h2>
      <div class="fs-17 mb-3">Have you compared or switched Energy here before? Save yourself some time by going
        straight to your dashboard.</div>
      <button [id]="id + '_UsedOurEnergyToolsBefore_SignIn'" class="btn btn-primary-outline" type="button"
        (click)="signIn()">Sign in</button>
    </div>
  </div>
  }

  <!-- Your details -->
  <div class="row">
    <div class="col-12 col-lg-6">
      <h4 class="my-3 fs-17">Your details</h4>
      <hr class="my-3">
    </div>
  </div>

  <!-- Postcode lookUp -->
  <div class="row">
    <div class="col-12 col-md-6">
      <h3 class="fs-23 mb-3 text-col40 fw400">What is your address?</h3>
      <app-postcode-lookup [isHomePage]="true" [isIndividual]="true" [regex]="regex" [isReset]="isReset"
        (resetComplete)="isReset = $event" (addedNewAddress)="getAddressDetails($event)"></app-postcode-lookup>
      @if (selectedAddress) {
      <!-- Selected address -->
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="boxTyp7 p-3">{{selectedAddress?.addressText}}</div>
          <button class="btn btn-secondary-link" type="button" (click)="changeAddress()">Change address</button>
        </div>
      </div>
      }
      <hr class="my-3">
    </div>
  </div>

  @if (selectedAddress) {
  @if (!isCurrentUsageLoading && !isSupplierLoading) {
  @if (!isExceptionalFlow) {
  <form [formGroup]="currentDetailsFormGroup">
    <!-- Fuel type selection -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <!-- <h3 class="fs-23 mb-2  text-col40 fw400">What's your current fuel type?</h3> -->
        <h3 class="fs-23 mb-3 text-col40 fw400">What do you want to compare?</h3>
        <!-- <div class="fs-17 mb-3">We've found your meters! We just need to confirm a few details about your current energy
          usage to make sure we show you the best deals.</div> -->

        <mat-radio-group class="radioBtnTyp1 d-flex flex-column" formControlName="fuelType">
          <mat-radio-button [id]="id + '_FuelType_Both'" class="cy-fuel-type" color="primary" value="Both"><span
              class="fs-17 text-col4">Gas & Electricity</span></mat-radio-button>
          <mat-radio-button [id]="id + '_FuelType_Electricity'" class="cy-fuel-type" color="primary"
            value="Electricity"><span class="fs-17 text-col4">Electricity only</span></mat-radio-button>
          <mat-radio-button [id]="id + '_FuelType_Gas'" class="cy-fuel-type" color="primary" value="Gas"><span
              class="fs-17 text-col4">Gas only</span></mat-radio-button>
        </mat-radio-group>

        <mat-error class="ctm-error d-block mb-3"
          *ngIf="!currentDetailsFormGroup?.get('fuelType')?.valid && currentDetailsFormGroup?.get('fuelType')?.touched">
          Please select your current fuel type to continue
        </mat-error>
        <hr class="my-3">
      </div>
    </div>

    @if (currentDetailsFormGroup?.get('fuelType')?.value === 'Both') {
    <!-- Is same supplier -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <!-- <h3 class="fs-23 mb-2  text-col40 fw400">Do you have the same supplier for both electricity and gas?</h3> -->
        <h3 class="fs-23 mb-3 text-col40 fw400">Are you on a dual fuel tariff?</h3>
        <div class="fs-17 mb-3">A dual fuel tariff gives you gas and electricity from the same supplier in one plan.
        </div>
        <mat-radio-group class="radioBtnTyp1 d-flex flex-column mb-3" formControlName="isSameSupplier">
          <mat-radio-button [id]="id + '_SameSupplier_Yes'" class="cy-same-supplier" color="primary" value="Yes"><span
              class="fs-17 text-col4">Yes</span></mat-radio-button>
          <mat-radio-button [id]="id + '_SameSupplier_No'" class="cy-same-supplier" color="primary" value="No"><span
              class="fs-17 text-col4">No</span></mat-radio-button>
        </mat-radio-group>
        <mat-error class="ctm-error d-block mb-3"
          *ngIf="!currentDetailsFormGroup?.get('isSameSupplier')?.valid && currentDetailsFormGroup?.get('isSameSupplier')?.touched">
          Please select an option to continue
        </mat-error>
        <hr class="my-3">
      </div>
    </div>

    @if (currentDetailsFormGroup?.get('isSameSupplier')?.value === 'Yes') {
    <!-- Both Fuel type - same supplier -->
    <div class="row mb-2">
      <div class="col-12 col-lg-6 mt-3">
        <h3 class="fs-23 fw700 text-col40 mb-2">Your current energy setup</h3>
        <div class="fs-17 mb-4">We’ve filled in some bits for you based on what we know about your current provider,
          tariff and payment information. Change anything that doesn’t look right.</div>
      </div>
    </div>

    <!-- Supplier for both electricity and gas -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2  text-col40 fw400">Who's your current energy supplier?</h3>
        <div class="fs-17 mb-3">Your provider will appear on a bill, bank statement or account.</div>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_SupplierName'" formControlName="supplierName" class="cy-same-supplier-name"
            placeholder="Select your energy supplier">
            @for (supplier of bothSupplierList; track supplier.id) {
            <mat-option [value]="supplier">{{ supplier.name }}</mat-option>
            } @empty {
            <mat-option disabled>No suppliers found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('supplierName')?.valid && currentDetailsFormGroup?.get('supplierName')?.touched">
            Please select your energy supplier to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <!-- End of supplier selection -->

    <!-- Payment method for both electricity and gas -->
    <div class="row mb-2">
      <div class="col-12 col-lg-6 mt-3">
        <h3 class="fs-23 mb-2 text-col40 fw400">How do you pay your energy bill?</h3>
        <button type="button" class="btn elink p-0 mb-3" style="text-decoration: underline; font-size: 14px;"
          (click)="openDialog()">
          Not sure which one to choose?
        </button>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_PaymentMethod'" formControlName="paymentMethod" class="cy-payment-method"
            placeholder="Select your payment method">
            @for (method of paymentList; track method.id) {
            <mat-option [value]="method">{{ method.name }}</mat-option>
            } @empty {
            <mat-option disabled>No payment methods found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('paymentMethod')?.valid && currentDetailsFormGroup?.get('paymentMethod')?.touched">
            Please select your payment method to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    @if (currentDetailsFormGroup?.get('paymentMethod')?.value) {
    <!-- Tariff for both electricity and gas -->
    <div class="row">
      <div class="col-12 col-lg-6 mt-3">
        <h3 class="fs-23 mb-2 text-col40 fw400">What energy tariff are you on?</h3>
        <div class="fs-17 mb-3">Your tariff will appear on a bill, yearly statement or account. Look for something like
          "your tariff" or "plan name".</div>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_TariffName'" formControlName="supplierTariff" class="cy-same-tariff-name"
            placeholder="Select your energy tariff">
            @for (tariff of bothTariffList; track tariff.id) {
            <mat-option [value]="tariff">{{ tariff.name }}</mat-option>
            } @empty {
            <mat-option disabled>No tariffs found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('supplierTariff')?.valid && currentDetailsFormGroup?.get('supplierTariff')?.touched">
            Please select your energy tariff to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    }
    <!-- End of payment method -->
    }
    <!-- End of same supplier Yes -->
    }
    <!-- End of Both Fuel type -->

    @if (currentDetailsFormGroup?.get('fuelType')?.value === 'Electricity' ||
    (currentDetailsFormGroup?.get('isSameSupplier')?.value === 'No' &&
    currentDetailsFormGroup?.get('fuelType')?.value === 'Both')) {
    <h3 class="fs-23 fw700 text-col40">Tell us about your energy usage</h3>
    <div class="fs-17 mb-3">We've filled in some bits for you based on what we know about your usage. Change anything
      that isn't right.</div>
    <!-- Electricity supplier -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 text-col40 fw400">Who's your current electricity provider?</h3>
        <div class="fs-17 mb-3">Your provider will appear on a bill, bank statement or account.</div>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_ElectricitySupplier'" formControlName="electricitySupplierName"
            class="cy-electricity-supplier" placeholder="Select your electricity supplier">
            @for (supplier of electricitySupplierList; track supplier.id) {
            <mat-option [value]="supplier">{{ supplier.name }}</mat-option>
            } @empty {
            <mat-option disabled>No suppliers found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('electricitySupplierName')?.valid && currentDetailsFormGroup?.get('electricitySupplierName')?.touched">
            Please select your electricity supplier to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    }
    <!-- End of Electricity or Both Fuel type and isSameSupplier No -->

    @if (currentDetailsFormGroup?.get('fuelType')?.value === 'Electricity' ||
    (currentDetailsFormGroup?.get('isSameSupplier')?.value === 'No') &&
    currentDetailsFormGroup?.get('fuelType')?.value === 'Both') {
    <!-- Electricity payment method -->
    <div class="row my-2">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 text-col40 fw400">How do you pay your electricity bill?</h3>
        <button type="button" class="btn elink p-0 mb-3" style="text-decoration: underline; font-size: 14px;"
          (click)="openDialog()">
          Not sure which one to choose?
        </button>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_ElectricityPaymentMethod'" formControlName="electricityPaymentMethod"
            class="cy-electricity-payment-method" placeholder="Select your electricity payment method">
            @for (method of electricityPaymentList; track method.id) {
            <mat-option [value]="method">{{ method.name }}</mat-option>
            } @empty {
            <mat-option disabled>No payment methods found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('electricityPaymentMethod')?.valid && currentDetailsFormGroup?.get('electricityPaymentMethod')?.touched">
            Please select your electricity payment method to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    @if (currentDetailsFormGroup?.get('electricityPaymentMethod')?.value) {
    <!-- Electricity tariff -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 text-col40 fw400">What is your current electricity tariff?</h3>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_ElectricityTariff_SameSupplier'" formControlName="electricitySupplierTariff"
            class="cy-electricity-tariff-same-supplier" placeholder="Select your electricity tariff">
            @for (tariff of electricityTariffList; track tariff.id) {
            <mat-option [value]="tariff">{{ tariff.name }}</mat-option>
            } @empty {
            <mat-option disabled>No tariffs found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('electricitySupplierTariff')?.valid && currentDetailsFormGroup?.get('electricitySupplierTariff')?.touched">
            Please select your electricity tariff to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    }
    <!-- End of Electricity payment method -->
    }
    <!-- End of Electricity or Both Fuel type and isSameSupplier No -->

    <!-- Separator for different supplier or tariff and both fuel types -->
    @if ((currentDetailsFormGroup?.get('isSameSupplier')?.value === 'No') &&
    currentDetailsFormGroup?.get('fuelType')?.value === 'Both') {
    <div class="row">
      <div class="col-12 col-lg-6">
        <hr class="my-3">
      </div>
    </div>
    }
    <!-- End of isSameSupplier and Both Fuel type -->
    @if (currentDetailsFormGroup?.get('fuelType')?.value === 'Gas' ||
    (currentDetailsFormGroup?.get('isSameSupplier')?.value === 'No' &&
    currentDetailsFormGroup?.get('fuelType')?.value === 'Both')) {
    <h3 class="fs-23 fw700 text-col40">About your gas supply</h3>
    <!-- Gas supplier -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 text-col40 fw400">Who is your current gas supplier?</h3>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_GasSupplier'" formControlName="gasSupplierName" class="cy-gas-supplier"
            placeholder="Select your gas supplier">
            @for (supplier of gasSupplierList; track supplier.id) {
            <mat-option [value]="supplier">{{ supplier.name }}</mat-option>
            } @empty {
            <mat-option disabled>No suppliers found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('gasSupplierName')?.valid && currentDetailsFormGroup?.get('gasSupplierName')?.touched">
            Please select your gas supplier to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    }
    <!-- End of isSameSupplier No and fuelType both or Gas -->

    @if (currentDetailsFormGroup?.get('fuelType')?.value === 'Gas' ||
    (currentDetailsFormGroup?.get('isSameSupplier')?.value === 'No') &&
    currentDetailsFormGroup?.get('fuelType')?.value === 'Both') {
    <!-- Gas payment method -->
    <div class="row mb-2">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 text-col40 fw400">How do you pay your gas bill?</h3>
        <button type="button" class="btn elink p-0 mb-3" style="text-decoration: underline; font-size: 14px;"
          (click)="openDialog()">
          Not sure which one to choose?
        </button>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_GasPaymentMethod'" formControlName="gasPaymentMethod" class="cy-gas-payment-method"
            placeholder="Select your gas payment method">
            @for (method of gasPaymentList; track method.id) {
            <mat-option [value]="method">{{ method.name }}</mat-option>
            } @empty {
            <mat-option disabled>No payment methods found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('gasPaymentMethod')?.valid && currentDetailsFormGroup?.get('gasPaymentMethod')?.touched">
            Please select your gas payment method to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    @if (currentDetailsFormGroup?.get('gasPaymentMethod')?.value) {
    <!-- Gas tariff -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 text-col40 fw400">What is your current gas tariff?</h3>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <mat-select [id]="id + '_GasTariff'" formControlName="gasSupplierTariff" class="cy-gas-tariff"
            placeholder="Select your gas tariff">
            @for (tariff of gasTariffList; track tariff.id) {
            <mat-option [value]="tariff">{{ tariff.name }}</mat-option>
            } @empty {
            <mat-option disabled>No tariffs found</mat-option>
            }
          </mat-select>
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('gasSupplierTariff')?.valid && currentDetailsFormGroup?.get('gasSupplierTariff')?.touched">
            Please select your gas tariff to continue
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    }
    <!-- End of gas payment method -->
    }
    <!-- End of both, isSameSupplier No or Gas -->

    @if (isFormCompleted() && isConsumptionSpendMissing) {
    <!-- Show energy profile - Current Spend(£) | Energy Usage(kWh)-->
    <div class="row">
      <div class="col-12 col-lg-6">
        <hr class="my-3">
        <h3 class="fs-23 mb-2 text-col40 fw400">Would you like to provide your current energy spend or usage?</h3>
        <mat-radio-group class="radioBtnTyp1 d-flex flex-column gap-2" formControlName="energyProfile">
          <mat-radio-button [id]="id + '_EnergyProfile_CurrentSpend'" class="cy-energy-profile" color="primary"
            value="currentSpend"><span class="fs-17 text-col4">GBG</span></mat-radio-button>
          <mat-radio-button [id]="id + '_EnergyProfile_EnergyUsage'" class="cy-energy-profile" color="primary"
            value="energyUsage"><span class="fs-17 text-col4">kWh</span></mat-radio-button>
        </mat-radio-group>
        <mat-error class="ctm-error d-block mb-3"
          *ngIf="!currentDetailsFormGroup?.get('energyProfile')?.valid && currentDetailsFormGroup?.get('energyProfile')?.touched">
          Please select an option to continue
        </mat-error>
      </div>
    </div>

    @if (currentDetailsFormGroup?.get('energyProfile')?.value) {
    <!-- Duration selection - Monthly or Annual -->
    <div class="row">
      <div class="col-12 col-lg-6 mt-3">
        <h3 class="fs-23 mb-2 text-col40 fw400">What is the duration?</h3>
        <mat-radio-group class="radioBtnTyp1 d-flex flex-column gap-2" formControlName="duration">
          <mat-radio-button [id]="id + '_Duration_Monthly'" class="cy-duration" color="primary" value="monthly"><span
              class="fs-17 text-col4">Monthly</span></mat-radio-button>
          <mat-radio-button [id]="id + '_Duration_Annual'" class="cy-duration" color="primary" value="annual"><span
              class="fs-17 text-col4">Annual</span></mat-radio-button>
        </mat-radio-group>
        <mat-error class="ctm-error d-block mb-3"
          *ngIf="!currentDetailsFormGroup?.get('duration')?.valid && currentDetailsFormGroup?.get('duration')?.touched">
          Please select a duration to continue
        </mat-error>
      </div>
    </div>
    }
    <!-- End of duration selection -->

    @if (currentDetailsFormGroup?.get('duration')?.value && currentDetailsFormGroup?.get('energyProfile')?.value &&
    (fuelType === 'Both' || fuelType === 'Electricity')) {
    <div class="row">
      <div class="col-12 col-lg-6 mt-3">
        @if (currentDetailsFormGroup?.get('energyProfile')?.value === 'currentSpend') {
        <h3 class="fs-23 mb-2 text-col40 fw400">Please enter your {{ currentDetailsFormGroup?.get('duration')?.value }}
          electricity spend (£)</h3>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <input matInput [id]="id + '_ElectricitySpend_Both'" formControlName="electricitySpend"
            class="cy-electricity-spend"
            placeholder="Enter your {{ currentDetailsFormGroup?.get('duration')?.value }} electricity spend in £">
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('electricitySpend')?.valid && currentDetailsFormGroup?.get('electricitySpend')?.touched">
            Please enter a valid electricity spend to continue
          </mat-error>
        </mat-form-field>
        } @else if (currentDetailsFormGroup?.get('energyProfile')?.value === 'energyUsage') {
        <h3 class="fs-23 mb-2 text-col40 fw400">Please enter your {{ currentDetailsFormGroup?.get('duration')?.value }}
          electricity usage (kWh)</h3>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <input matInput [id]="id + '_ElectricityConsumption_Both'" formControlName="electricityConsumption"
            class="cy-electricity-consumption"
            placeholder="Enter your {{ currentDetailsFormGroup?.get('duration')?.value }} electricity usage in kWh">
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('electricityConsumption')?.valid && currentDetailsFormGroup?.get('electricityConsumption')?.touched">
            Please enter a valid electricity usage to continue
          </mat-error>
        </mat-form-field>
        }
      </div>
    </div>
    }
    <!-- End of Electricity energy profile selection, Current Spend(£) | Energy Usage(kWh) -->

    @if (currentDetailsFormGroup?.get('duration')?.value && currentDetailsFormGroup?.get('energyProfile')?.value &&
    (fuelType === 'Both' || fuelType === 'Gas')) {
    <div class="row">
      <div class="col-12 col-lg-6 mt-3">
        @if (currentDetailsFormGroup?.get('energyProfile')?.value === 'currentSpend') {
        <h3 class="fs-23 mb-2 text-col40 fw400">Please enter your {{ currentDetailsFormGroup?.get('duration')?.value }}
          gas spend (£)</h3>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <input matInput [id]="id + '_GasSpend_Both'" formControlName="gasSpend" class="cy-gas-spend"
            placeholder="Enter your {{ currentDetailsFormGroup?.get('duration')?.value }} gas spend in £">
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('gasSpend')?.valid && currentDetailsFormGroup?.get('gasSpend')?.touched">
            Please enter a valid gas spend to continue
          </mat-error>
        </mat-form-field>
        } @else if (currentDetailsFormGroup?.get('energyProfile')?.value === 'energyUsage') {
        <h3 class="fs-23 mb-2 text-col40 fw400">Please enter your {{ currentDetailsFormGroup?.get('duration')?.value }}
          gas usage (kWh)</h3>
        <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
          appearance="fill" subscriptSizing="dynamic">
          <input matInput [id]="id + '_GasConsumption_Both'" formControlName="gasConsumption" class="cy-gas-consumption"
            placeholder="Enter your {{ currentDetailsFormGroup?.get('duration')?.value }} gas usage in kWh">
          <mat-error class="ctm-error"
            *ngIf="!currentDetailsFormGroup?.get('gasConsumption')?.valid && currentDetailsFormGroup?.get('gasConsumption')?.touched">
            Please enter a valid gas usage to continue
          </mat-error>
        </mat-form-field>
        }
      </div>
    </div>
    }
    <!-- End of Gas energy profile selection, Current Spend(£) | Energy Usage(kWh) -->
    }
    <!-- End of tariff selection -->
  </form>
  }

  @if (currentDetailsFormGroup?.valid || !!isExceptionalFlow) {
  <form [formGroup]="contactDetailsFormGroup">
    <!-- Email confirmation -->
    <div class="row">
      <div class="col-12 col-lg-6">
        @if (!isExceptionalFlow) {
        <hr class="mt-4">
        }
        <h3 class="fs-23 mb-2 text-col40 fw400">What is your email?</h3>
        <div class="fs-17 mb-3">The energy provider needs this to send you confirmation of your switch. If you opt-in to
          receive emails from us, we’ll send you those too.</div>
        <div
          [ngClass]="!contactDetailsFormGroup?.get('email')?.valid && contactDetailsFormGroup?.get('email')?.touched ? 'error-bar' : ''">
          <mat-form-field floatLabel='never' class="w-100 example-form-field ctm-input input-error-overflow"
            appearance="fill" subscriptSizing="dynamic">
            <input autocomplete="email" [id]="id + '_email'" matInput
              class="cy-email inputTyp2 fw500 sessioncamexclude sessioncamhidetext maskpii" formControlName="email"
              type="text" aria-label="Enter your email address." maxlength="256" appBlockCopyPaste />
            <mat-error aria-hidden="true" class="ctm-error"
              *ngIf="!contactDetailsFormGroup?.get('email')?.valid && contactDetailsFormGroup?.get('email')?.touched">
              <span *ngIf="contactDetailsFormGroup?.get('email')?.hasError('required')">Email is required</span>
              <span *ngIf="contactDetailsFormGroup?.get('email')?.hasError('pattern')"> Invalid email address</span>
              <span *ngIf="contactDetailsFormGroup?.get('email')?.hasError('invalid')"> {{
                contactDetailsFormGroup?.get('email')?.getError('invalid') }}</span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- CTM Marketing consent -->
    <div class="row mt-4">
      <div class="col-12 col-lg-6">
        <h3 class="fs-23 mb-2 text-col40 fw400">{{ supplierConfig?.CTMMarketingConsent?.title }}</h3>
        <div class="contact-consent my-3" [innerHTML]="supplierConfig?.CTMMarketingConsent?.description"></div>
        <div class="radioBtnTyp1 fs-17 checkbox-radio-group"
          [ngClass]="!contactDetailsFormGroup?.get('consent')?.valid && contactDetailsFormGroup?.get('consent')?.touched ? 'error-bar' : ''">
          @for (option of marketingConsentList; track option?.id) {
          <div class="mb-1">
            <mat-checkbox [id]="id + '_ChooseHowWeContactYou_' + option?.name?.replaceAll(' ', '_')" type="checkbox"
              class="cy-consent ctm-checkbox-large" color="primary" [(value)]="option.name"
              [checked]="option?.isChecked"
              (change)="selectedMarketingConsent($event, option)">{{option?.name}}</mat-checkbox>
          </div>
          }
          <mat-error class="ctm-error"
            *ngIf="!contactDetailsFormGroup?.get('consent')?.valid && contactDetailsFormGroup?.get('consent')?.touched">
            Please select one of the options to continue
          </mat-error>
        </div>
        @if (supplierConfig?.CTMMarketingConsent?.consentHint?.isVisible) {
        <div>
          <mat-accordion class="example-headers-align">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title [id]="id + '_consentHint'" class="cy-consent-hint elink">
                  {{ supplierConfig?.CTMMarketingConsent?.consentHint?.title }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              {{ supplierConfig?.CTMMarketingConsent?.consentHint?.description }}
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        }
      </div>
    </div>
  </form>

  <!-- Terms and conditions -->
  <div class="row mt-4">
    <div class="col-12 col-lg-6">
      <div class="fs-13 lh-1 mb-3">
        We share your information with third parties, which includes retrieving your current and previous energy
        information. By continuing you accept our <a class="elink"
          href="https://www.comparethemarket.com/information/terms-and-conditions/" target="_blank">terms and
          conditions</a>, which includes confirming you have the bill-payers permission to access the data. Please see
        our <a class="elink" href="https://www.comparethemarket.com/information/privacy-policy/" target="_blank">privacy
          policy</a> to understand how we will use your information to provide the service to you.
      </div>
    </div>
  </div>

  <!-- Action button -->
  <div class="footer-container" [ngClass]="{'sticky-above-footer': isFooterSticky, 'above-footer': !isFooterSticky}">
    <div class="mt-3 pt-4 row border-2 border-top">
      <div class="col-12 col-lg-6">
        <div class="btn-container d-grid d-lg-flex justify-content-lg-between gap-3 gap-lg-0 mb-2">
          <button id="backButton" class="btn btn-primary-outline order-2 order-lg-1" type="button"
            (click)="back()">Back</button>
          <button id="nextButton" class="btn btn-primary order-1 order-lg-2" type="button"
            [ngClass]="isSubmitting ? 'animate' : ''"
            [disabled]="isExceptionalFlow ? (isSubmitting || contactDetailsFormGroup?.invalid) : (isSubmitting || currentDetailsFormGroup?.invalid || contactDetailsFormGroup?.invalid)"
            (click)="submit()">
            <span class="spinner"></span>
            <span class="text">Get quotes</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  }
  <!-- End of form validation -->

  } @else {
  <!-- Skeleton loader -->
  <div class="skeleton-wrapper">
    <div class="container px-0">
      <div class="skeleton-wrapper-inner px-0">
        <div class="skeleton-wrapper-body">
          <div class="row noBG">
            <div class="col-12 col-lg-6 noBG">
              <div class="bg-ctmDefaultSurface h-100 text-center">
                <div class="p-3 w-50"></div>
                <div class="p-4 mt-3"></div>
                <hr class="my-3">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  <!-- End of currentUsage Loader -->
  }
  <!-- End of selected address -->

  } @else {
  <!-- If regex is not loaded -->
  <div class="skeleton-wrapper">
    <div class="container px-0">
      <div class="skeleton-wrapper-inner px-0">
        <div class="skeleton-wrapper-body">
          <div class="row noBG">
            <div class="col-12 col-lg-6 noBG">
              <div class="bg-ctmDefaultSurface h-100 text-center">
                <div class="p-3 w-50"></div>
                <div class="p-4 mt-3"></div>
                <hr class="my-3">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="skeleton-wrapper">
    <div class="container px-0">
      <div class="skeleton-wrapper-inner px-0">
        <div class="skeleton-wrapper-body">
          <div class="row noBG">
            <div class="col-12 col-lg-6 noBG">
              <div class="bg-ctmDefaultSurface h-100 text-center">
                <div class="p-3 w-50"></div>
                <div class="p-2 mt-3 w-25"></div>
                <div class="p-1 mt-2"></div>
                <div class="p-1 mt-2 w-50"></div>
                <div class="p-2 mt-3 w-25"></div>
                <div class="p-1 mt-2"></div>
                <div class="p-1 mt-2 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <div class="p-3 mt-3 w-50"></div>
                <hr class="my-3">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>